import React from 'react';
import { ActivityIndicator, Alert, Pressable, StyleSheet, Text, View } from 'react-native';
import { D } from './theme';

/** 카카오 브랜드 가이드의 지정 색. 다른 색을 쓰면 심사에서 걸린다. */
const KAKAO_YELLOW = '#FEE500';
const KAKAO_LABEL = '#191600';

/**
 * 카카오 로그인 버튼.
 *
 * 네이티브 모듈이라 웹 미리보기에서는 동작하지 않는다. 그래서 import 를 화면 로드 시점이 아니라
 * 누른 시점으로 미룬다 — 웹 번들이 통째로 깨지는 걸 막는다.
 */
export function KakaoButton({ onDone, note }: { onDone?: (nickname: string) => void; note?: string }) {
  const [busy, setBusy] = React.useState(false);

  async function press() {
    if (busy) return;
    setBusy(true);
    try {
      const { signInWithKakao } = await import('./kakao');
      const { nickname } = await signInWithKakao();
      onDone?.(nickname);
    } catch (e) {
      const msg = e instanceof Error ? e.message : String(e);
      // 사용자가 로그인 창을 닫은 건 오류가 아니다
      if (!/cancel|취소|user_cancelled/i.test(msg)) {
        Alert.alert('로그인하지 못했어요', msg);
      }
    } finally {
      setBusy(false);
    }
  }

  return (
    <View style={{ gap: 6 }}>
      <Pressable onPress={press} disabled={busy} style={({ pressed }) => [s.btn, (busy || pressed) && { opacity: 0.85 }]}>
        {busy ? (
          <ActivityIndicator size="small" color={KAKAO_LABEL} />
        ) : (
          <Text style={s.label}>카카오로 3초 만에 시작하기</Text>
        )}
      </Pressable>
      {note ? <Text style={s.note}>{note}</Text> : null}
    </View>
  );
}

const s = StyleSheet.create({
  btn: { height: 48, borderRadius: 14, backgroundColor: KAKAO_YELLOW, alignItems: 'center', justifyContent: 'center' },
  label: { fontSize: 15, fontWeight: '700', color: KAKAO_LABEL },
  note: { fontSize: 12, lineHeight: 18, color: D.ink2, textAlign: 'center' },
});
